import * as $ from "jquery";
import tracking from '../../utils/tracking';

export default class ShowroomAnalytics {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  
  constructor(componentRoot: HTMLElement, params: any) {
    this.componentRoot = $(componentRoot);
    this.params = params;

    this.init();
  }

  init() {
    const { prefix, analyticsDataAttribute } = this.params;

    $("[data-showroom-analytic-event]").on('click', function() {
      const eventName = $(this).data(analyticsDataAttribute);
      const templateName = $(this).data('template-name');
      return tracking.trackEvent(`${prefix}.${eventName}`, templateName ? templateName : {});
    });
  }
}
